import { IAnalyticsEvent } from '@verv-inc/js-toolkit';

interface PinterestEventAddToCardParameters {
	value: number;
	orderQuantity: number;
	currency: string;
}

interface PinterestEventCheckoutParameters {
	value: number;
	orderQuantity: number;
	currency: string;
	eventID: string;
	productIDs: string[];
}

export const PinterestEvent = {
	addToCard: (parameters: PinterestEventAddToCardParameters): IAnalyticsEvent => {
		return {
			name: 'addtocart',
			info: {
				value: parameters.value,
				order_quantity: parameters.orderQuantity,
				currency: parameters.currency,
			},
		};
	},
	checkout: (parameters: PinterestEventCheckoutParameters): IAnalyticsEvent => {
		return {
			name: 'checkout',
			info: {
				value: parameters.value,
				order_quantity: parameters.orderQuantity,
				currency: parameters.currency,
				event_id: parameters.eventID,
				product_ids: parameters.productIDs,
			},
		};
	},
};
